import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useToast, useAuth } from "@/comn/hooks";
import { Group, Layout, Tab } from "@/comn/components";
import { api } from "@/comn";

type Aprv = {
    aprvRqstTtleNm: string;
    aprvRqstDtm: string;
    aprvId: string;
};

type Todo = {
    todoId: string;
    todoPrcdStatCd: string;
    bsopClsfCd: string;
    scrnDocCd?: string;
    todoReffId: string;
    todoUsrId: string;
    todoUsrIdList: string;
    bsopClsfCdNm: string;
    todoBsopDvn: string;
    frstRgsrDtm: string;
};

export const TancisPortalMainTab = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();

    const [foundTodo, setTodo] = useState<Todo[]>([]);
    const [foundAprv, setAprv] = useState<Aprv[]>([]);

    const handleError = (error: any) => {
        const content = error.response?.data?.errorMessage || "error";
        showToast({ content, type: "error" });
    };

    const findToDo = async () => {
        try {
            let base = process.env.REACT_APP_API_PTLI || "",
                path = `/api/v1/ptl/comn/comn/main/todo`;
            const response = await api.get(base + path);
            const content = response.data.todoList.content;
            setTodo(content);
        } catch (error) {
            handleError(error);
            console.log(error);
        }
    };

    const findAprv = async () => {
        try {
            let base = process.env.REACT_APP_API_PTLI || "",
                path = `/api/v1/ptl/comn/comn/main/aprv`;
            const response = await api.get(base + path);
            const content = response.data.aprvList.content;
            setAprv(content);
        } catch (error) {
            handleError(error);
            console.log(error);
        }
    };

    useEffect(() => {
        findToDo();
    }, []);

    useEffect(() => {
        findAprv();
    }, []);

    return (
        <Group>
            <Group.Header>
                <h2>
                    {t("T_MY_TODO")} / {t("L_APRV_PROG_TAB")}
                </h2>
            </Group.Header>
            <Group.Body>
                <Group.Section>
                    <Layout padding={6}>
                        <Tab schema={[{ label: "My Todo", active: true }, { label: "Requested" }]}>
                            <Tab.Panel>
                                <TodoPanel foundTodo={foundTodo} />
                            </Tab.Panel>
                            <Tab.Panel>
                                <AprvPanel foundAprv={foundAprv} />
                            </Tab.Panel>
                        </Tab>
                    </Layout>
                </Group.Section>
            </Group.Body>
        </Group>
    );
};

const TodoPanel = (props: any) => {
    const { foundTodo } = props;

    const handleMoveTodoDtl = (todo: any) => {
        if (todo.todoReffId !== null) {
            if (todo.todoReffId.charAt(0) !== "/") {
                todo.todoReffId = "/" + todo.todoReffId;
            }
        }
        const scrnDocUrlAddr = todo.scrnDocUrlAddr + todo.todoReffId;

        let frontDmn;
        const getBsopClsfCd = todo.bsopClsfCd;

        if (getBsopClsfCd == "PTL") {
            frontDmn = process.env.REACT_APP_API_FRONT_PTLI;
        } else if (getBsopClsfCd == "ESW") {
            frontDmn = process.env.REACT_APP_API_FRONT_ESWI;
        } else if (getBsopClsfCd == "CLR") {
            frontDmn = process.env.REACT_APP_API_FRONT_CLRI;
        } else if (getBsopClsfCd == "COL") {
            frontDmn = process.env.REACT_APP_API_FRONT_COLI;
        } else if (getBsopClsfCd == "PCL") {
            frontDmn = process.env.REACT_APP_API_FRONT_PCLI;
        } else if (getBsopClsfCd == "CGM") {
            frontDmn = process.env.REACT_APP_API_FRONT_CGMI;
        } else if (getBsopClsfCd == "SCT") {
            frontDmn = process.env.REACT_APP_API_FRONT_SCTI;
        } else if (getBsopClsfCd == "ECT") {
            frontDmn = process.env.REACT_APP_API_FRONT_ECTI;
        } else if (getBsopClsfCd == "EFM") {
            frontDmn = process.env.REACT_APP_API_FRONT_EFMI;
        } else if (getBsopClsfCd == "OLM") {
            frontDmn = process.env.REACT_APP_API_FRONT_OLMI;
        } else if (getBsopClsfCd == "LCM") {
            frontDmn = process.env.REACT_APP_API_FRONT_LCMI;
        } else if (getBsopClsfCd == "TDW") {
            frontDmn = process.env.REACT_APP_API_FRONT_TDWI;
        } else if (getBsopClsfCd == "CLB") {
            frontDmn = process.env.REACT_APP_API_FRONT_CLBI;
        } else if (getBsopClsfCd == "PCA") {
            frontDmn = process.env.REACT_APP_API_FRONT_CLRI;
        } else {
            frontDmn = process.env.REACT_APP_API_FRONT_RKMI;
        }

        // 추후 삭제 할 것 (도메인 동일함)
        todo.todoReffId.indexOf("?") === -1
            ? window.open(
                `${frontDmn}${scrnDocUrlAddr}?menuId=mytodo&ptlTodoPrcdStatCd=${todo.ptlTodoPrcdStatCd}`,
                "_parent",
            )
            : window.open(
                `${frontDmn}${scrnDocUrlAddr}&menuId=mytodo&ptlTodoPrcdStatCd=${todo.ptlTodoPrcdStatCd}`,
                "_parent",
            );
        // window.open(`/ptli/usr/cstm/ptli0901003s/TZGT?todoReffVal1=11&menuId=mytodo`, "_parent");

        // 추후 사용할 것
        // const param = rowValues.todoReffVal;
        // navigate(`/ptli/usr/cstm/ptli0901003s/TZGT`, { state: { todoReffVal1: "111" } });
    };

    return (
        <ul className="flex flex-col gap-4">
            {foundTodo.map((todo: any, index: any) => (
                <li key={index} className="flex items-start justify-between gap-8 relative">
                    <div className="w-1 h-1 bg-primary-text rounded-full absolute left-0 top-2" />
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            handleMoveTodoDtl(todo);
                        }}
                        className="ml-2 text-left text-primary-text line-clamp-2 underline"
                    >
                        {todo.todoBsopDvn}
                    </button>
                    <span className="text-darkgray w-24 text-right text-sm">{todo.frstRgsrDtm}</span>
                </li>
            ))}
        </ul>
    );
};

const AprvPanel = (props: any) => {
    const { foundAprv } = props;
    const navigate = useNavigate();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    return (
        <ul className="flex flex-col gap-4">
            {foundAprv.map((aprv: any, index: any) => (
                <li key={index} className="flex items-start justify-between gap-8 relative">
                    <div className="w-1 h-1 bg-primary-text rounded-full absolute left-0 top-2" />
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(`/ptli/comnmdle/aprv/ptli0409005s/${aprv.aprvId}/${auth.get("usrId")}?flag=P&menuId=menu_ptli0011`);
                        }}
                        className="ml-2 text-left text-primary-text line-clamp-2 underline"
                    >
                        {aprv.aprvRqstTtleNm}
                    </button>
                    <span className="text-darkgray w-24 text-right text-sm">{aprv.aprvRqstDtm}</span>
                </li>
            ))}
        </ul>
    );
};
